// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__7vgBY","container":"MainLayout_container__s5oXx","body":"MainLayout_body__uEF0T","content":"MainLayout_content__nOiKO"};